import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Grid, Typography, Card, CardContent, CardMedia, Divider, Box, Paper, List, ListItem, ListItemText } from "@mui/material";
import { styled } from '@mui/system';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// Importe a imagem de fundo localmente
import fundoImagem from '../../assets/ImgFundo/fundo-abstratoB.jpg'; // Ajuste o caminho conforme necessário

const AutoreIndex = ( ) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { id } = useParams();
  const [autor, setAutores] = useState(null);

  const getAutores = async (url) => {
    const res = await fetch(url);
    const data = await res.json();
    setAutores(data);
  };
 
  useEffect(() => {
    const autorUrl = `${apiUrl}/autores/${id}`;
    getAutores(autorUrl);
  }, [apiUrl, id]);

  const createMarkup = (html) => {
    return { __html: html };
  };

  const AuthorCard = styled(Card)({
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-10px)',
      boxShadow: '0 8px 30px rgba(0, 0, 0, 0.1)',
    },
  });

  // Definir o tema para o Material-UI com a fonte Lato
  const theme = createTheme({
    typography: {
      fontFamily: '"Lato", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
  <Box
  sx={{
    minHeight: '100vh',
    background: `url(${fundoImagem}) no-repeat center center fixed`, // Usando a imagem importada da pasta assets
    backgroundSize: 'cover',
    padding: '1rem',
    width: '100%', // Faz o Box ocupar 100% da largura disponível
    maxWidth: '1500px', // Aumenta a largura máxima
    margin: '0 auto', // Centraliza o Box na tela
  }}
>
        <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
        <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

        <Container sx={{ my: 4, maxWidth: '1200px', width: '100%' }}>
        <Box sx={{ textAlign: "center", mb: 6 }}>
            <Typography
              variant="h2"
              align="center"
              gutterBottom
              style={{
                fontFamily: "'Lato', serif",
                color: "#800020",
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                borderBottom: "4px solid #d4af37",
                paddingBottom: "10px",
                textTransform: "uppercase",
                animation: "glow 2s infinite alternate",
                marginTop: "7%"  // Aqui é onde você define o espaço superior
              }}
            >
              Perfil do Autor
            </Typography>
          </Box>

          {autor && (
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} sm={8} md={6}>
              <AuthorCard>
  <CardMedia
    component="img"
    alt={autor.nome}
    height="400"
    image={autor.imagem}
    title={autor.nome}
    sx={{ objectFit: 'cover' }}
  />
  <CardContent>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
      <Typography variant="h4" component="h1" fontWeight="bold">
        {autor.nome}
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Typography
        variant="h6"
        sx={{
          textAlign: 'center',
          color: '#444',
          fontFamily: "'Lato', sans-serif",
          fontWeight: 500,
          letterSpacing: '0.5px',
          padding: '8px 0',
          borderBottom: '2px solid rgba(0, 0, 0, 0.1)',
          display: 'inline-block',
        }}
      >
        {autor.instituicao}
      </Typography>
    </Box>
    <Divider sx={{ my: 2 }} />
    <Box sx={{ fontSize: '1rem', color: 'text.primary' }}>
      <Typography variant="body1" paragraph>
        <span dangerouslySetInnerHTML={createMarkup(autor.linkcv)} />
      </Typography>
    </Box>
  </CardContent>
</AuthorCard>




                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  p={3}
                  sx={{
                    backgroundColor: '#FED13E', // Amarelo claro para o fundo do Box
                    borderRadius: '12px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Sombra suave para profundidade
                    width: '100%', // Ocupar toda a largura disponível
                    margin: '30px 0',
                  }}
                >
                  {/* Título com ícone */}
                  <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>

                    <Typography
                      variant="h4"
                      sx={{
                        fontFamily: "'Lato', serif",
                        color: "#5A0000", // Um bordô mais escuro para contraste
                        textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
                        borderBottom: "4px solid #b8860b",
                        paddingBottom: "12px",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                        letterSpacing: "1.2px",

                        animation: "glow 2s infinite alternate",
                      }}
                    >SOBRE</Typography>

                  </Typography>

                  {/* Conteúdo com fundo cinza */}
                  <Box sx={{ backgroundColor: '#f5f5f5', padding: '16px', borderRadius: '8px', width: '100%' }}>
                    <Typography variant="body1" color="textSecondary" paragraph>

                      <span dangerouslySetInnerHTML={createMarkup(autor.descricao)} />
                    </Typography>  </Box>
                </Box>







                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  p={3}
                  sx={{
                    backgroundColor: '#FED13E', // Amarelo claro para o fundo do Box
                    borderRadius: '12px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Sombra suave para profundidade
                    width: '100%', // Ocupar toda a largura disponível
                    margin: '30px 0',
                  }}
                >
                  {/* Título com ícone */}
                  <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                    <Typography
                      variant="h4"
                      sx={{
                        fontFamily: "'Lato', serif",
                        color: "#5A0000", // Um bordô mais escuro para contraste
                        textShadow: "3px 3px 6px rgba(0, 0, 0, 0.3)",
                        borderBottom: "4px solid #b8860b",
                        paddingBottom: "12px",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                        letterSpacing: "1.2px",

                        animation: "glow 2s infinite alternate",
                      }}
                    >
                      Trabalhos Relevantes
                    </Typography>
                  </Typography>

                  <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
                    <Divider sx={{ my: 2 }} />

                    {/* Renderizando a lista de trabalhos separadamente */}
                    <List>
                    {autor.trabalhos ? (
        <Typography variant="body1" dangerouslySetInnerHTML={{ __html: autor.trabalhos }} />
      ) : (
        <Typography variant="body1" color="textSecondary">
          Nenhum trabalho disponível.
        </Typography>
      )}
     
    </List>


                  </Paper>
                </Box>

              </Grid>
            </Grid>
          )}
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default AutoreIndex;
